// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__32LNz","gfeWrapper":"CalendarEvent_gfeWrapper__n_4xz"};